import React, { useState, useEffect } from "react"
import { mutate } from "swr"
import { toast } from "react-toastify"

/** Context */
import Service from "services/Settings/AccountManagement/Staff"
import { Context } from "./Context"

/** Services */

const Provider: React.FC = ({ children }) => {
  const [showForm, setShowForm] = useState(false)
  const [resetForm, showResetForm] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [userData, setUserData] = useState({})
  const [activeData, setActiveData] = useState({})
  const [formType, setFormType] = useState(1)

  /**
   * Notification
   */
  const notifyDelete = () =>
    toast(`Successfully deleted the User.`, {
      type: toast.TYPE.SUCCESS
    })

  function showFormType(state: boolean, type: number) {
    setShowForm(state)
    setFormType(type)
  }

  function resetData() {
    setActiveData({})
  }

  async function handleDeleteUser(itemUID: string, apiName: string) {
    setIsDeleting(true)
    try {
      const response = await Service.deleteStaffUser(itemUID)
      await mutate(apiName)
      notifyDelete()
      setIsDeleting(false)
      return response
    } catch (e) {
      setIsDeleting(false)
      return e
    }
  }

  useEffect(() => {
    resetData()
  }, [])

  return (
    <Context.Provider
      value={{
        showForm,
        activeData,
        resetForm,
        userData,
        isDeleting,
        resetData,
        setShowForm,
        setActiveData,
        showFormType,
        showResetForm,
        setUserData,
        handleDeleteUser,
        formType
      }}
    >
      {children}
    </Context.Provider>
  )
}

export default Provider
